import { FC, SVGProps } from 'react';

export const DiscountLimitIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M4.75 16C4.75 9.7868 9.7868 4.75 16 4.75C16.4142 4.75 16.75 4.41421 16.75 4C16.75 3.58579 16.4142 3.25 16 3.25C8.95837 3.25 3.25 8.95837 3.25 16C3.25 23.0416 8.95837 28.75 16 28.75C18.3976 28.75 20.6427 28.0875 22.5597 26.9352C22.9148 26.7218 23.0296 26.261 22.8162 25.906C22.6028 25.551 22.142 25.4362 21.787 25.6496C20.0967 26.6656 18.1178 27.25 16 27.25C9.7868 27.25 4.75 22.2132 4.75 16Z"
			fill="currentColor"
		/>
		<path
			d="M18.7482 3.52067C18.3397 3.45214 17.953 3.72774 17.8844 4.13625C17.8159 4.54475 18.0915 4.93147 18.5 5C19.1568 5.11019 19.7942 5.27728 20.4069 5.49601C20.797 5.63527 21.2262 5.43191 21.3654 5.0418C21.5047 4.6517 21.3013 4.22257 20.9112 4.08332C20.216 3.83515 19.493 3.64562 18.7482 3.52067Z"
			fill="currentColor"
		/>
		<path
			d="M24.1524 6.19646C23.834 5.93146 23.3611 5.9747 23.0961 6.29305C22.8311 6.6114 22.8744 7.0843 23.1927 7.34931C24.2036 8.19082 25.0646 9.20603 25.7299 10.3487C25.9383 10.7067 26.3974 10.828 26.7554 10.6196C27.1133 10.4112 27.2346 9.95203 27.0262 9.59406C26.2723 8.29906 25.2971 7.14934 24.1524 6.19646Z"
			fill="currentColor"
		/>
		<path
			d="M28.5564 13.7749C28.4846 13.3669 28.0956 13.0945 27.6877 13.1663C27.2798 13.2381 27.0073 13.6271 27.0791 14.035C27.1914 14.6726 27.25 15.3291 27.25 16C27.25 16.7882 27.1691 17.5568 27.0153 18.298C26.9311 18.7036 27.1917 19.1006 27.5973 19.1847C28.0028 19.2689 28.3998 19.0083 28.484 18.6027C28.6585 17.7619 28.75 16.8912 28.75 16C28.75 15.2415 28.6837 14.498 28.5564 13.7749Z"
			fill="currentColor"
		/>
		<path
			d="M26.9528 22.8686C27.1926 22.5309 27.1133 22.0627 26.7756 21.8228C26.4379 21.583 25.9697 21.6623 25.7299 22C25.2824 22.63 24.7717 23.212 24.2069 23.7367C23.9035 24.0187 23.8861 24.4932 24.168 24.7967C24.45 25.1001 24.9245 25.1175 25.228 24.8356C25.8675 24.2414 26.4459 23.5822 26.9528 22.8686Z"
			fill="currentColor"
		/>
	</svg>
);
